import { render, staticRenderFns } from "./AstaChatMessages.vue?vue&type=template&id=c41fb99a&scoped=true&"
import script from "./AstaChatMessages.vue?vue&type=script&lang=js&"
export * from "./AstaChatMessages.vue?vue&type=script&lang=js&"
import style0 from "./AstaChatMessages.vue?vue&type=style&index=0&id=c41fb99a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41fb99a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c41fb99a')) {
      api.createRecord('c41fb99a', component.options)
    } else {
      api.reload('c41fb99a', component.options)
    }
    module.hot.accept("./AstaChatMessages.vue?vue&type=template&id=c41fb99a&scoped=true&", function () {
      api.rerender('c41fb99a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AstaChatMessages.vue"
export default component.exports